import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import { store } from './store/store'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBZg7Xg0Z1f-TQESC8_RNP-c49Oob1lcWY',
    libraries: 'places',
  }
});

// navigation guards before each
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		  next()
      window.scroll(0, 0)		
	} else {
		next() // make sure to always call next()!
    window.scroll(0, 0)
	}
})

axios.defaults.baseURL = 'https://api.eventsonline.app'
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

Vue.mixin({
	data() {
		return {
        
      }
    },
    computed: {
        
    },
    methods: {
      formatCurrency(value, formatCurrency = true, localeInfo1 = this.$store.getters.getUserauthResponse) {
        //let localeInfo = this.$store.getters.getUserauthResponse
          let localeInfo = localeInfo1.locale_info
          if(formatCurrency) {
              
              var n = value, 
              c = localeInfo.decimal_allowed ? 2 : 0, 
              d = localeInfo.decimal_separator, 
              t = localeInfo.thousand_separator, 
              s = n < 0 ? "-" : "", 
              i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
              j = (j = i.length) > 3 ? j % 3 : 0;
              

              if(localeInfo.decimal_allowed) {
                  return localeInfo.currency_symbol+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
              } else {
                  return localeInfo.currency_symbol+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
              }
              
            
          } else {
              return (value).toFixed(localeInfo.maxFraction)
          }
    },
    formatCurrencyNoPrefix(value, formatCurrency = true, localeInfo1 = this.$store.getters.getUserauthResponse) {
        //let localeInfo = this.$store.getters.getUserauthResponse
          let localeInfo = localeInfo1.locale_info
          if(formatCurrency) {
            
              var n = value, 
              c = localeInfo.max_fraction, 
              d = localeInfo.decimal_separator, 
              t = localeInfo.thousand_separator, 
              s = n < 0 ? "-" : "", 
              i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
              j = (j = i.length) > 3 ? j % 3 : 0;
              
              if(localeInfo.max_fraction>0) {
                  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
              } else {
                  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
              }
              
            
          } else {
              return (value).toFixed(localeInfo.maxFraction)
          }
    },
    changeDate(value, $offset = false) {

        var monthNames = [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ];
        
        let date = new Date(value)
        if($offset) {
            date = new Date( date.getTime() + Math.abs(date.getTimezoneOffset()*60000) )
        }

        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        
        if(day<10) {
            day = "0"+day
        }
        return day + ' ' + monthNames[monthIndex] + ' ' + year;

    },
    changeDateTime(value) {

        return this.changeDate(value)+', '+value.substring(value.indexOf(' '))   

    },
    changeTime(value) {

        let date = new Date(value)
        
        var hour = date.getHours();
        var minutes = date.getMinutes();
        
        if(hour<10) {
            hour = "0"+hour
        }
        if(minutes<10) {
            minutes = "0"+minutes
        }
        return hour + ':' + minutes;

    }		
    }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js